import React from "react";
import Form from "react-bootstrap/Form";

interface InputSwitchProps {
  id: string;
  value: boolean;
  placeholder?: string;
  onChange: () => void;
  className?: string;
    disabled?: boolean;
}
const InputSwitch = React.memo(({ id, placeholder, value, onChange, className, disabled = false }: InputSwitchProps) => {
  return (
      <Form.Check
          type="switch"
          className={className || "form-switch-lg"}
          id={id}
          checked={value || false}
          onChange={onChange}
          label={placeholder || null}
          disabled={disabled}
      />
  );
});
export default InputSwitch;
